import { Outlet } from 'react-router-dom';

// Wrapper das rotas do Centro. Modelo launcher (como a referência): o /centro é
// o hub de tiles; cada sub-ecrã é uma página própria (com o seu título e o
// botão Centro da tab-bar para voltar) — consistência total, sem pills híbridas.
export function CentroLayout() {
  return <Outlet />;
}
